/* eslint no-undef: 0 */
import axios from 'axios';
import qs from 'qs';
// import CryptoJS from 'crypto-js';
import interceptors from '../business/interceptors';
import roleErrorMap from '../config/errcode';
import { errorMsg } from '../utils/error-handler';
import { isPromise } from '../utils/helper';
import { commonLoading } from '../utils/loading';
import config from '../config';

// 默认配置
axios.defaults.timeout = 15000;
axios.defaults.headers['Content-Type'] = 'application/json';
// axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let request,
  requestWx3rd,
  requestFd;

request = axios.create({
  baseURL: '',
  maxRedirects: 0,
});

requestWx3rd = axios.create({
  baseURL: '',
  headers: {
    'Content-Type': 'application/json',
    'Authorization': 'tif_qywxid=c5fd7b5d693f7165c8d8d4fca2302d8ab4cb4',
  },
});

requestFd = axios.create({
  method: 'post',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
  transformRequest: [
    function (data) {
      Object.keys(data).forEach(key => {
        if (typeof data[key] === 'object') {
          data[key] = JSON.stringify(data[key]);
        }
      });
      return qs.stringify(data);
    }],
});

/**
 * 拦截器成功回调
 * 所有接口返回0才正常返回resolve
 * 非0都reject出去
 * @param res
 * @returns {*}
 */
function resolve (res) {
  const { data = {} } = res || {};
  if (!res.config.hideLoading) {
    commonLoading.hide();
  }

  if (+data.errcode !== 0) {
    // 调试模式下，非0统一提示
    if (config.debugModel) {
      console.warn(
        '接口非0啦！错误信息看这里！',
        '\n responseURL:', res.request.responseURL,
        '\n data: ', res.data,
        '\n all message: ', res);
    }

    let promise;

    // 19000未登录，由业务配置决定是否reject
    if (+data.errcode === 19000 && interceptors.noLogin) {
      promise = interceptors.noLogin(data);
    }

    if (+data.errcode === 41001 && interceptors.noMpAuth) {
      promise = isPromise(promise)
        ? promise.then(() => {
          return interceptors.noMpAuth(data);
        })
        : interceptors.noMpAuth(data, res.config.params.appid);
    }

    if (interceptors.roleCheck) {
      promise = isPromise(promise)
        ? promise.then(() => {
          return interceptors.roleCheck(data);
        })
        : interceptors.roleCheck(data);
    }

    if (roleErrorMap[data.errcode]) {
      promise = isPromise(promise)
        ? promise.then(() => {
          return Promise.reject(roleErrorMap[data.errcode]);
        })
        : Promise.reject(new Error(roleErrorMap[data.errcode]));
    }

    // 1. 如果在错误码总表里面，则默认通过toast展示文字错误
    // 2. 支持在业务逻辑中catch对应的错误码进行个性化处理
    if (promise && typeof promise.catch === 'function') {
      return promise.catch(err => {
        errorMsg(err.message);
        return Promise.reject(data);
      });
    }

    return Promise.reject(data);
  }

  if (typeof data.data !== 'undefined') {
    return data.data;
  }
  return data;
}

// 失败，一般是网络错误
function reject (error) {
  if (!error.config.hideLoading) {
    commonLoading.hide();
  }
  console.log('=====> error.response', error.response);
  if (error.message.indexOf('401') === -1) {
    errorMsg(error.message);
  }
  return Promise.reject(error);
}

request.interceptors.request.use(function (conf) {
  // 后续需要下沉的system_id逻辑在此编辑
  const isSystem = window.location.pathname.match(
    '/(system/|manage|ability/apply|cdn)');
  if (isSystem && isSystem.index === 0) {
    conf.headers['X-Tif-Sid'] = window.localStorage.getItem(config.lsSidName);
  }
  if (!conf.hideLoading) {
    commonLoading.show('拉取数据中，请稍候...');
  }
  return conf;
});

request.interceptors.response.use(resolve, reject);
requestFd.interceptors.response.use(resolve, reject);
requestWx3rd.interceptors.response.use(resolve, reject);

export {
  request,
  requestFd,
  requestWx3rd,
};
